module.exports = __webpack_public_path__ + "public/StoreIcon/veg.svg?8274e674";